import { render, staticRenderFns } from "./HsabExpenseSubmitConfirmation.vue?vue&type=template&id=3999812f&scoped=true"
import script from "./HsabExpenseSubmitConfirmation.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseSubmitConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3999812f",
  null
  
)

export default component.exports